import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SortEvent } from 'primeng/api';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { ResultOfT } from 'src/app/models/response/result';
import { UserInfoResponseModel } from 'src/app/models/response/userInfo-response';
import { UserService } from 'src/app/services/user.service';
import { WebStorageService } from 'src/app/services/web-storage.service';
import { BaseComponent } from 'src/app/shared/base.component';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-inception-admin-users',
    templateUrl: './inception-admin-users.component.html',
    styleUrls: ['./inception-admin-users.component.sass']
})

export class InceptionAdminUsersComponent extends BaseComponent implements OnInit, OnDestroy {
    private unsubscriber = new Subject<boolean>();
    private progress = new Subject<boolean>();
    UsersDeletePopup: boolean;

    userId: number;
    role: string;
    displayMessage: boolean;
    messageClass: boolean;
    message: any;
    searchText: string = '';
    users: UserInfoResponseModel[];
    selectedUser: UserInfoResponseModel;
    ResendLink: boolean = false;
    selectedUserId: number;
    isEditMode: boolean;
    refreshForm: boolean;
    ManageUserPopup: boolean;

    constructor(private userService: UserService, private webstorageService: WebStorageService, private changeDetectorRef: ChangeDetectorRef) {
        super();

        let currentUser = this.webstorageService.getCurrentUserToken();
        if (currentUser) {
            this.userId = currentUser.userId;
            this.role = currentUser.role;
        }
    }

    ngOnDestroy(): void {
        if (this.unsubscriber) {
            this.unsubscriber.next();
            this.unsubscriber.complete();
        }
        if (this.progress) {
            this.progress.complete();
        }
    }

    ngOnInit(): void {
        // debugger;
        this.selectedUser = new UserInfoResponseModel();
        this.getAllInceptionAdminUsers('');
    }

    getAllInceptionAdminUsers(searchText: string) {
        this.loading = true;
        this.userService.GetAllInceptionAdmins(searchText)
            .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
            .subscribe((result: ResultOfT<UserInfoResponseModel[]>) => {
                this.processResult<any>(result, () => {
                    if (result.IsSuccess) {
                        if (result.ResponseModel) {

                            this.users = result?.ResponseModel;

                        }
                        this.loading = false;
                    }
                    else {
                        this.loading = false;
                        this.timeoutFunct(result.Message, false);
                    }
                });
            }, (httpResponseError) => {
                this.loading = false;
                this.timeoutFunct(httpResponseError.message, false);
            });
    }

    timeoutFunct(msg, isSuccess: boolean) {
        this.displayMessage = true;
        this.messageClass = isSuccess;
        this.message = msg;
        setTimeout(() => {
            this.message = '';
            this.displayMessage = false;
        }, environment.messageLifeSpan);
    }

    openUsersDeletePopup(event: any, user: UserInfoResponseModel) {
        this.UsersDeletePopup = true;
        this.selectedUser = user;
    }

    ClosePopup(event: any) {        
        this.ManageUserPopup = false;
        // this.PermissionPopup = false;
        this.refreshForm = false;
        if(event === true) {
          this.getAllInceptionAdminUsers('');
        }
      }

    ManageUserPopupClick(isEditMode: boolean, userId: number) {
    // debugger;
        this.selectedUserId = 0;
        this.changeDetectorRef.detectChanges();
        this.isEditMode = isEditMode;
        this.refreshForm = true;
        this.ManageUserPopup = true;
        this.selectedUserId = userId;      
    
      }

    ResendPasswordLinkPopup(user: UserInfoResponseModel) {
        this.ResendLink = true;
        this.selectedUser = user;
    }

    customSort(event: SortEvent) {
        event.data.sort((data1, data2) => {
            let value1 = data1[event.field];
            let value2 = data2[event.field];
            let result = null;

            if (value1 == null && value2 != null)
                result = -1;
            else if (value1 != null && value2 == null)
                result = 1;
            else if (value1 == null && value2 == null)
                result = 0;
            else if (typeof value1 === 'string' && typeof value2 === 'string')
                result = value1.localeCompare(value2);
            else
                result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

            return (event.order * result);
        });
    }

    closeMessagePopup() {
        this.displayMessage = false;
    }

    onAddIconClick() {

    }

    onSearchChange(e: any) {
        this.getAllInceptionAdminUsers(this.searchText);
    }

    closeDeletePopup() {
        this.UsersDeletePopup = false;

    }

    onClickYes() {
        this.loading = true;
        this.userService.deleteUser(this.selectedUser.UserId, this.userId)
            .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
            .subscribe((result: ResultOfT<boolean>) => {
                this.processResult<any>(result, () => {
                    if (result.IsSuccess) {
                        this.closeDeletePopup();
                        this.getAllInceptionAdminUsers('');
                        this.timeoutFunct(this.selectedUser.FirstName + ' ' + this.selectedUser.LastName + ' deleted successfully.', true);
                    }
                    else {
                        this.loading = false;
                        this.closeDeletePopup();
                        this.timeoutFunct(result.Message, false);
                    }
                });
            }, (httpResponseError) => {
                this.loading = false;
                this.closeDeletePopup();
                this.timeoutFunct(httpResponseError.message, false);
            });
    }


    cancelSendingLink() {
        this.ResendLink = false;
    }

    sendLink() {
        this.loading = true;
        this.userService.resendUserPasswordResetLink(this.selectedUser.UserId, this.userId)
            .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false))).subscribe(
                (result: any) => {

                    this.processResult<any>(result, () => {
                        if (result.IsSuccess) {
                            this.ResendLink = false;
                            this.getAllInceptionAdminUsers('');
                            this.timeoutFunct('Email sent successfully to ' + this.selectedUser.Email, true);
                        }
                        else {
                            this.loading = false;
                            this.ResendLink = false;
                            this.timeoutFunct(result.Message, false);
                        }
                    });
                }
            )
    }

}
